// removed by extract-text-webpack-plugin
module.exports = {"root":"_zxFV0","media":"_3j1gD","imageLink":"_yaRZy","mediaImage":"_1uIcZ","mobileMedia":"_3umkD","block":"_jAQUi"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Banner/Banner.scss
// module id = 1121
// module chunks = 2